<template>
  <div>
    <div v-wechat-title="pageLanguage.pageTitle"></div>
    <div :class="'thirdAnniversary-page ' + language">
      <div class="header">
        <div class="text top">{{ pageLanguage.title }}</div>
        <div class="text bottom">
          {{
            user_info.user_id ? `${user_info.nick_name}` : pageLanguage.slogan
          }}
        </div>
        <div class="btn download" @click="goLink(pageLanguage.download, '欧美三周年组队活动_组队顶部-下载')"></div>
        <div class="btn login" v-show="!user_info.user_id" @click="login()"></div>
        <div class="btn logout" v-show="user_info.user_id" @click="logout()"></div>
      </div>

      <!-- 内容 -->

      <div class="active-page">
        <div class="section-container">
          <div class="section section1">
            <div class="banner"></div>
            <div class="banner-download-btn" data-snail-report-name="banner-下载游戏"
              @click="goLink(pageLanguage.download, '欧美三周年组队活动-下载游戏')"></div>

            <div class="team-consumption-box" id="team-consumption-box">
              <div class="detail-btn" data-snail-report-name="组队消费-详情按钮" @click="showPopup('teamDetailShow')"></div>
              <div class="time" v-if="isActiveAppointment">
                <img class="time_2" :src="pageLanguage.isActiveAppointment" alt="" />
              </div>
              <div class="time" v-else>
                <img class="time_1" :src="pageLanguage.isActiveAppointmentPre" alt="" />
              </div>
              <div class="team-consumption-content">
                <div class="member-num">
                  {{ pageLanguage.team }}【{{ memberNum }}/6】
                  <div v-if="isActiveAppointment &&
                    userInfo.user_id &&
                    memberNum &&
                    !teamOutStatus
                    " class="exit-btn" @click="showPopup('teamExitShow')"></div>
                </div>
                <div class="member-list">
                  <ul>
                    <li v-for="(item, idx) in teamList" :key="idx">
                      <div v-if="item.id" class="player-info" @click="readPlayerInfo(item.id)">
                        <img class="avatar" :src="item.pic" alt="" />
                        <div class="name">
                          {{
                            item.is_myself ? pageLanguage.self : item.nick_name
                          }}
                        </div>
                        <div v-if="item.is_first" class="captain"></div>

                        <div v-if="item.is_kick_out" class="member" @click.stop="kickoutPlayer(item.id)"></div>
                      </div>
                      <div v-else>
                        <div class="player-info empty-seat" data-snail-report-name="组队付费-邀请好友" @click="onTeamShare()">
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
                <div v-if="memberNum === 6" class="full-capacity-btn"></div>
                <div v-else class="invitation-btn" data-snail-report-name="组队付费-邀请好友" @click="onTeamShare()"></div>
              </div>
              <div :class="'egg-btn pause-' + eggPause" data-snail-report-name="组队消费-彩蛋按钮"
                @click="showPopup('eggPopShow')"></div>
            </div>
            <div class="find_team_btn" @click="openFindTeamShow()">
              <img :src="pageLanguage.find_team_btn" alt="" />
            </div>
            <div class="beter-energy-cube-box"></div>

            <div class="consumption-points-box">
              <div class="operation-box">
                <div class="role-info" v-if="!userInfo.user_id">
                  <!-- <p>尚未登录</p> -->
                  <div class="no-login"></div>
                </div>
                <div v-if="userInfo.rid && language === 'en'" class="role-info">
                  <p class="name">{{ userInfo.nick_name }}</p>
                </div>
                <div class="team-points">
                  {{ pageLanguage.team_code }}&nbsp;<span>{{
                    teamScore || 0
                  }}</span>
                  <b data-snail-report-name="查看积分列表" @click="onMorePoints()"></b>
                </div>
                <div class="login-mask" v-if="!userInfo.user_id" data-snail-report-name="积分领取登录"
                  @click="openLoginByScore()"></div>
              </div>
              <div class="go_immediately_btn" data-snail-report-name="组队付费-前往官充" @click="pointToRecharge()"></div>

              <div class="welfare-list">
                <div class="reward-box" v-for="(item, idx) in packageList" :key="idx">
                  <div :class="'reward-item reward-item-' + (idx + 1)">
                    <div :class="'title title-' + (idx + 1)"></div>
                    <div class="lock-box">
                      <div :class="'lock lock-' + (idx + 1) + ' lock_' + item.status
                        " :data-snail-report-name="'奖励礼包' + (idx + 1)"></div>
                      <div :class="'lock_status ' + item.status"></div>
                      <div class="text">
                        <p class="lock_criterion">
                          {{ teamScore || 0 }}/{{ item.score
                          }}{{ pageLanguage.power }}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="activities-box">
              <div class="title"></div>
              <div class="activities-content">
                <div class="activities-swiper-container">
                  <div class="swiper-wrapper">
                    <div class="swiper-slide" v-for="card in pageLanguage['activitiesCards' + language]" :key="card.id">
                      <div class="content">
                        <img :src="card.image" alt="">
                      </div>
                    </div>
                  </div>
                </div>
                <div class="btn-go" @click="enterUrl" :class="{
                  disabled: isNotStarted(
                    pageLanguage['activitiesCards' + language].find(
                      (i, index) => index === activeIndex
                    ).time
                  )
                }"></div>
                <div class="activities-swiper-button-next swiper-button-next"></div>
                <div class="activities-swiper-button-prev swiper-button-prev"></div>
                <!-- <div
                  class="activities-swiper-pagination swiper-pagination"
                ></div> -->
              </div>
            </div>

            <!-- 组队消费分享 -->
          </div>
        </div>
      </div>

      <!-- 彩蛋弹窗 -->
      <div class="egg-pop-wrap popup_wrap" v-show="eggPopShow">
        <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight"
          :duration="{ enter: 1000 }">
          <div class="egg-btn-box popup_wrap-box" v-show="eggPopShow">
            <div class="monitor-btn" @click="onCopy('egg-clipboard-btn')" id="egg-clipboard-btn"
              data-snail-report-name="复制密令" data-event="复制密令" :data-clipboard-text="pageLanguage.eggDesc"></div>
            <div class="confirm-btn" @click="closePopup('eggPopShow')"></div>
          </div>
        </transition>
        <div class="close-bg" v-show="eggPopShow" @click="closePopup('eggPopShow')"></div>
      </div>

      <!-- 组队消费弹窗组 -->
      <div>
        <!-- 组队消费——详情弹窗 -->
        <div class="team-detail-wrap popup_wrap" v-show="teamDetailShow">
          <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight"
            :duration="{ enter: 1000 }">
            <div class="team-detail-box popup_wrap-box" v-show="teamDetailShow">
              <div class="detail-content" v-if="teamDetailShow">
                <img :src="pageLanguage.rule" alt="" />
              </div>
            </div>
          </transition>
          <div class="close-bg" v-show="teamDetailShow" @click="closePopup('teamDetailShow')"></div>
        </div>

        <!-- 组队消费——踢出队伍弹窗 -->
        <div class="team-kickout-wrap popup_wrap" v-show="teamKickoutShow">
          <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight"
            :duration="{ enter: 1000 }">
            <div class="team-kickout-box popup_wrap-box" v-show="teamKickoutShow">
              <div class="player-info">
                <div class="top">
                  <div class="avatar-box">
                    <img class="avatar" :src="curPlayerInfo.pic" alt="" />
                  </div>
                  <div class="name">{{ curPlayerInfo.nick_name || "" }}</div>
                </div>
              </div>

              <div :class="'btn-box align-' + curPlayerInfo.is_kick_out">
                <div class="btn" v-if="curPlayerInfo.is_kick_out">
                  <div v-if="showGrayKickOutBtn" class="gray-kick-out-btn">
                    <span>{{ pageLanguage.Cooldown }}:{{ kickOutSeconds }}s</span>
                  </div>
                  <div v-else class="kick-out-btn" @click="onKickOut()"></div>
                </div>
                <div class="btn confirm-btn" @click="closePopup('teamKickoutShow')"></div>
              </div>
            </div>
          </transition>
          <div class="close-bg" v-show="teamKickoutShow" @click="closePopup('teamKickoutShow')"></div>
        </div>

        <!-- 组队消费——队友信息 -->
        <div class="team-player-info-wrap popup_wrap" v-show="teamPlayerInfoShow">
          <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight"
            :duration="{ enter: 1000 }">
            <div class="team-player-info-box popup_wrap-box" v-show="teamPlayerInfoShow">
              <div class="player-info">
                <div class="top">
                  <div class="avatar-box">
                    <img class="avatar" :src="curPlayerInfo.pic" alt="" />
                  </div>
                  <div class="name">{{ curPlayerInfo.nick_name || "" }}</div>
                </div>

                <div class="info">
                  <p class="row">
                    <span class="label">{{ pageLanguage.Contribution }}</span>
                    <span class="value">{{ contributionValue }}</span>
                  </p>
                </div>
              </div>
              <div class="btn confirm-btn" @click="closePopup('teamPlayerInfoShow')"></div>
            </div>
          </transition>
          <div class="close-bg" v-show="teamPlayerInfoShow" @click="closePopup('teamPlayerInfoShow')"></div>
        </div>

        <!-- 组队消费——玩家退出队伍弹窗 -->
        <div class="team-exit-wrap popup_wrap" v-show="teamExitShow">
          <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight"
            :duration="{ enter: 1000 }">
            <div class="team-exit-box popup_wrap-box" v-show="teamExitShow">
              <div class="btn-box">
                <div class="btn confirm-btn" data-snail-report-name="退出队伍弹窗-确认退出" @click="onExitTeam()"></div>
                <div class="btn cancel-btn" @click="closePopup('teamExitShow')"></div>
              </div>
            </div>
          </transition>
          <div class="close-bg" v-show="teamExitShow" @click="closePopup('teamExitShow')"></div>
        </div>

        <!-- 组队消费——积分记录弹窗 -->
        <div class="team-points-record-wrap popup_wrap" v-show="teamPointsRecordShow">
          <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight"
            :duration="{ enter: 1000 }">
            <div class="team-points-record-box popup_wrap-box" v-show="teamPointsRecordShow">
              <div class="record-box">
                <ul>
                  <li v-for="(item, idx) of scoreList" :key="idx">
                    <div class="name">{{ item.remark }}</div>
                    <div class="date">{{ item.time }}</div>
                    <div class="score">{{ item.score }}</div>
                  </li>
                </ul>
              </div>

              <div class="tips">
                <p>
                  {{ pageLanguage.Cumulative }}：<span>{{
                    teamScore || 0
                  }}</span>
                </p>
              </div>
            </div>
          </transition>
          <div class="close-bg" v-show="teamPointsRecordShow" @click="closePopup('teamPointsRecordShow')"></div>
        </div>
        <!-- 组队消费——积分记录弹窗 无积分 -->
        <div class="team-not-points-record-wrap popup_wrap" v-show="teamNotPointsRecordShow">
          <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight"
            :duration="{ enter: 1000 }">
            <div class="team-not-points-record-box popup_wrap-box" v-show="teamNotPointsRecordShow">
              <div class="btn-box">
                <div class="btn confirm-btn" data-snail-report-name="组队付费-获取积分" @click="toRecharge('积分记录弹窗', 'official')">
                </div>
              </div>
            </div>
          </transition>
          <div class="close-bg" v-show="teamNotPointsRecordShow" @click="closePopup('teamNotPointsRecordShow')"></div>
        </div>

        <!-- 组队消费——入队失败(满员) -->
        <div class="team-join-failed-full-strength-wrap popup_wrap" v-show="teamJoinFailedFullStrengthShow">
          <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight"
            :duration="{ enter: 1000 }">
            <div class="team-join-failed-full-strength-box popup_wrap-box" v-show="teamJoinFailedFullStrengthShow">
              <div class="btn-box">
                <div class="btn other-active-btn" @click="closePopup('teamJoinFailedFullStrengthShow')"></div>
              </div>
            </div>
          </transition>
          <div class="close-bg" v-show="teamJoinFailedFullStrengthShow"
            @click="closePopup('teamJoinFailedFullStrengthShow')"></div>
        </div>
        <!-- 组队消费——入队失败(已有队伍) -->
        <div class="team-join-failed-has-team-wrap popup_wrap" v-show="teamJoinFailedHasTeamShow">
          <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight"
            :duration="{ enter: 1000 }">
            <div class="team-join-failed-has-team-box popup_wrap-box" v-show="teamJoinFailedHasTeamShow">
              <div class="btn-box">
                <!-- <div
                  class="btn other-active-btn"
                  @click="closePopup('teamJoinFailedHasTeamShow')"
                ></div> -->
                <div class="btn my-team-btn" @click="toMyTeamByTeam()"></div>
              </div>
            </div>
          </transition>
          <div class="close-bg" v-show="teamJoinFailedHasTeamShow" @click="closePopup('teamJoinFailedHasTeamShow')"></div>
        </div>
        <!-- 组队消费——入队失败(自己邀请自己) -->
        <div class="team-join-failed-myself-wrap popup_wrap" v-show="teamJoinFailedMyselfShow">
          <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight"
            :duration="{ enter: 1000 }">
            <div class="team-join-failed-myself-box popup_wrap-box" v-show="teamJoinFailedMyselfShow">
              <div class="btn-box">
                <div class="btn other-active-btn" @click="closePopup('teamJoinFailedMyselfShow')"></div>
              </div>
            </div>
          </transition>
          <div class="close-bg" v-show="teamJoinFailedMyselfShow" @click="closePopup('teamJoinFailedMyselfShow')"></div>
        </div>
        <!-- 组队消费——邀请入队弹窗 -->
        <div class="team-invitation-join-wrap popup_wrap" v-show="teamInvitationJoinShow">
          <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight"
            :duration="{ enter: 1000 }">
            <div class="team-invitation-join-box popup_wrap-box" v-show="teamInvitationJoinShow">
              <div v-if="isActiveAppointment" class="tip-01"></div>
              <div v-else class="tip-02"></div>
              <div class="btn-box">
                <div class="btn reject-btn" data-snail-report-name="组队消费-拒绝入队"
                  @click="closePopup('teamInvitationJoinShow')"></div>
                <div class="btn agree-btn" data-snail-report-name="组队消费-立即入队" @click="agreeJoinTeam()"></div>
              </div>
            </div>
          </transition>
          <div class="close-bg" v-show="teamInvitationJoinShow" @click="closePopup('teamInvitationJoinShow')"></div>
        </div>
        <!-- 组队消费——邀请入队确认弹窗 -->
        <div class="team-invitation-confirm-wrap popup_wrap" v-show="teamInvitationConfirmShow">
          <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight"
            :duration="{ enter: 1000 }">
            <div :class="!isActiveAppointment
              ? 'popup_wrap-box team-invitation-confirm-box'
              : 'popup_wrap-box team-invitation-confirm-box-pre'
              " v-show="teamInvitationConfirmShow">
              <div class="btn-box">
                <div class="btn confirm-btn" data-snail-report-name="组队消费-二次确认确定入队" @click="agreeJoinTeam()"></div>
                <div class="btn cancel-btn" data-snail-report-name="组队消费-二次确认拒绝入队"
                  @click="closePopup('teamInvitationConfirmShow')"></div>
              </div>
            </div>
          </transition>
          <div class="close-bg" v-show="teamInvitationConfirmShow" @click="closePopup('teamInvitationConfirmShow')"></div>
        </div>
      </div>
      <!-- 组队消费——分享弹窗 -->
      <div class="team-share-wrap popup_wrap" v-show="teamNotWechatShareShow">
        <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight"
          :duration="{ enter: 1000 }">
          <div class="team-share-box popup_wrap-box" v-show="teamNotWechatShareShow">
            <!-- <div class="share-link">{{ teamShareLink }}</div> -->
            <img :src="pageLanguage.share_warp" />
            <button class="monitor-btn" @click="onCopy('team-clipboard-btn')" id="team-clipboard-btn"
              data-snail-report-name="付费活动弹窗-复制链接" data-event="复制邀请链接"
              :data-clipboard-text="teamShareCopy.linkText + teamShareLink"></button>
          </div>
        </transition>
        <div class="close-bg" v-show="teamNotWechatShareShow" @click="closePopup('teamNotWechatShareShow')"></div>
      </div>

      <!-- 寻找组队搭子 -->

      <div class="find-team-wrap popup_wrap" v-show="findTeamShow">
        <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight"
          :duration="{ enter: 1000 }">
          <div class="find-team-box popup_wrap-box" v-show="findTeamShow">
            <div class="btn-box" v-if="language === 'en'">
              <div class="discord-btn btn" data-snail-report-name="寻找搭子弹窗-去discord" @click="
                goLink(
                  pageLanguage.discord,
                  '欧美三周年组队活动_寻找组队搭子-discord'
                )
                "></div>
            </div>
          </div>
        </transition>
        <div class="close-bg" v-show="findTeamShow" @click="closePopup('findTeamShow')"></div>
      </div>
    </div>

    <LoadingPopup />
    <!-- 全局遮罩 -->
    <div :class="'prevent-wrap prevent-wrap-' + preventShow"></div>
  </div>
</template>

<script>
import Clipboard from "clipboard";
import { Toast, Indicator } from "mint-ui";
import { mapState, mapMutations, mapActions } from "vuex";
import {
  onGetAccountDataAPI,
  onGetInitDataAPI,
  onGetFreeLoginAPI,
  onGetTimeAPI,
  teamInitAPI,
  teamKickAPI,
  teamExitAPI,
  teamRewardAPI,
  teamJoinAPI,
  GetRoleList
} from "../api";
import QCJumpAuthPlugin from "@qcplay/jump-auth";
import { getRandomString, buriedLogger, analysisParams } from "@/utils/utils";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/css/swiper.css";
import { languages } from "../language";
import LoadingPopup from "@/components/Loading/index.vue";

// import eruda from 'eruda';

const PLAYER_TYPE = {
  1: "Active Players",
  2: "Returning Players",
  3: "New Players"
};
const ACTIVE_APPOINTMENT_STATUS = 1; // 活动预约期间
// const ACTIVE_APPOINTMENT_STATUS = 2; // 活动期间
const PAGE_LANG = "en";
export default {
  name: "RecallTeamActive",
  components: {
    swiper,
    swiperSlide,
    LoadingPopup
  },
  data () {
    return {
      languages: languages,
      language: PAGE_LANG,
      pageLanguage: languages[PAGE_LANG],

      activeIndex: 0,
      user_info: {}, // 用户信息,
      user_id: null,
      isShowInfo: true,
      rid: "",
      gameName: "en_snail",
      rechargeUrl: "https://pay.qcplay.com/pay",
      timer: null,
      kickOutTimer: null,
      kickOutSeconds: 0,
      showGrayKickOutBtn: false,
      teamShareCopy: {
        title: "",
        desc: "",
        linkText: ""
      },

      code: "",
      auth_code: "",
      friend_id: "",
      recallShareLink: "",
      teamShareLink: "",
      recallShareImg: "",
      teamShareImg: "",
      server_token: "",

      activitiesSwiper: null,
      currentTime: "",
      // 弹窗
      eggPopShow: false, // 彩蛋弹窗
      preventShow: false, // 全局遮罩
      snailRoleSelect: false, // 角色选择
      findTeamShow: false, // 寻找队伍弹窗
      eggPause: false,

      teamOutStatus: false, // 预约期和正式活动期中间的空档五小时
      teamKickoutShow: false, // 组队消费——玩家信息弹窗
      teamDetailShow: false, // 组队消费——详情弹窗
      teamNotWechatShareShow: false, // 组队消费——非微信分享弹窗
      teamPlayerInfoShow: false, // 组队消费——玩家信息弹窗
      teamExitShow: false, // 组队消费——退出队伍弹窗
      teamPointsRecordShow: false, // 组队消费——积分记录弹窗
      teamNotPointsRecordShow: false, // 组队消费——积分记录弹窗 无积分
      teamJoinFailedFullStrengthShow: false, // 组队消费——入队失败(满员)
      teamJoinFailedHasTeamShow: false, // 组队消费——入队失败(已有队伍)
      teamJoinFailedMyselfShow: false, // 组队消费——入队失败(自己邀请自己)
      teamInvitationJoinShow: false, // 组队消费——邀请入队弹窗
      teamInvitationConfirmShow: false, // 组队消费——邀请入队确认弹窗

      recallActiveInfo: {},
      teamActiveInfo: {},
      teamList: Array.from({ length: 6 }, () => ({})),
      packageList: [],
      memberNum: 0,
      curPlayerInfo: {},

      // 是否需要二次同意
      needInvitationConfirm: false,

      roleList: [],
      selectedRoleID: "",
      isActiveAppointment: true, // 默认在预约期
      isActiveAppointmentPre: false, // 正式期
      recallSharePlayerInfo: {},
      teamInvitationNum: 0,
      teamLevel: 0,
      teamScore: 0,
      scoreList: [],
      rewardLevel: 0,
      rewardList: [],
      selectedRoleInfo: {},
      pageLink: "",
      logger: null,
      targetDateFlag: false
    };
  },
  async created () {
    // 获取当前时间
    await onGetTimeAPI().then(res => {
      if (res.code !== 200) {
        return;
      }
      this.currentTime = this.pageLanguage.timeBalance(res.data.time);
    });
    // console.log("this.currentTime", this.pageLanguage);
    this.packageList = this.pageLanguage.packageList;
    const targetDate = new Date("2026/7/24 4:59:59");
    const targetDateOver = new Date("2026/7/31 4:59:59");
    this.token = localStorage.getItem(this.pageLanguage.token);
    this.access_token = localStorage.getItem(this.pageLanguage.access_token);

    const currentDate = new Date(this.currentTime).getTime();

    // 是否处于预约期：当前时间 >= 预约开始时间 且 当前时间 < 正式活动开始时间
    this.isActiveAppointment = currentDate >= targetDate && currentDate < targetDateOver;

    // 是否进入正式组队时间：当前时间 >= 正式组队开始时间
    this.isActiveAppointmentPre = currentDate >= targetDateOver;

    // console.log("this.currentTime", this.currentTime);
    // console.log("this.isActiveAppointment", this.isActiveAppointment);
    // console.log("this.isActiveAppointmentPre", this.isActiveAppointmentPre);

    this.pageLink = window.location.href;

    // 获取url上的参数
    const urlParams = new URLSearchParams(window.location.search);
    const urlRoleId = urlParams.get("role_id");
    const cachedRoleId = localStorage.getItem("role_id");

    this.code = urlParams.get("code");
    this.auth_code = urlParams.get("auth_code");
    this.friend_id = urlParams.get("friend_id");
    const module = urlParams.get("module");

    // console.log("this.friend_id:", this.friend_id);

    urlParams.delete("role_id");
    urlParams.delete("code");
    urlParams.delete("auth_code");
    urlParams.delete("friend_id");
    urlParams.delete("module");
    const newUrl =
      window.location.pathname +
      (urlParams.toString() ? "?" + urlParams.toString() : "");
    window.history.replaceState(null, "", newUrl);

    // 清空store上的用户数据
    this.setInitActiveInfo();
    this.setInitUserInfo();

    // 创建一个数组，长度为6，里面元素是空对象
    this.teamList = Array.from({ length: 6 }, () => ({}));

    // 埋点
    const bl = buriedLogger(this.pageLanguage.bl, "欧美三周年组队活动");
    this.logger = bl;
    if (urlRoleId && urlRoleId !== cachedRoleId) {
      // 免密登录
      onGetFreeLoginAPI({
        game_id: this.pageLanguage.sdkObj.game_id,
        role_id: urlRoleId
      }).then(response => {
        if (Number(response.code) == 200) {
          this.access_token = response.data.access_token;
          localStorage.setItem(
            this.pageLanguage.access_token,
            this.access_token
          );
          localStorage.setItem("role_id", urlRoleId);
          // 初始化
          this.onInitDate(true);
        } else {
          this.onToast(response.message);
          this.clearDate();
          localStorage.clear();
          this.onInitQCHW();
        }
      });
    } else if (!urlRoleId && !this.access_token) {
      this.access_token ? "" : this.onInitQCHW();
      setTimeout(() => {
        onGetAccountDataAPI({
          game_id: this.pageLanguage.sdkObj.game_id,
          token: this.token,
          platform: this.pageLanguage.sdkObj.platform,
          email: this.email
        }).then(response => {
          if (Number(response.code) == 200) {
            this.access_token = response.data.access_token;
            localStorage.setItem(
              this.pageLanguage.access_token,
              this.access_token
            );
            // 初始化
            this.onInitDate(true);
          }
        });
      }, 500);
    } else {
      this.onInitDate(true);
    }

    if (module === "team") {
      this.$nextTick(() => {
        this.scrollIntoTeamBox();
      });
    }
  },
  mounted () {
    setTimeout(() => {
      this.initSwiper();
    }, 500);
    document.addEventListener("click", this.handleGlobalClick, true);
  },
  computed: {
    roleName () {
      // 当区组为空时, 角色名为空
      let roleName = this.selectedRoleID
        ? this.roleList.find(item => item.role_id === this.selectedRoleID)
          .role_name
        : "";
      return roleName;
    },
    contributionValue () {
      if (this.isActiveAppointment) {
        return 0;
      }

      const score = Number(this.curPlayerInfo && this.curPlayerInfo.score) || 0;

      const gaveScore =
        Number(
          this.activeInfo &&
          this.activeInfo.team &&
          this.activeInfo.team.gave_score
        ) || 0;

      return score + gaveScore;
    },
    ...mapState(["userInfo", "activeInfo", "isShowLogin"])
  },
  watch: {
    userInfo: {
      handler (newValue, oldValue) {
        if (!oldValue || typeof oldValue !== "object") return;

        if (!newValue.user_id && oldValue.user_id) {
          // TAG: 注销的时候
          // this.clearDate();
        } else if (newValue.user_id !== oldValue.user_id) {
          // TAG: 初始登陆/切换角色的时候
          this.getTeamInit();
          const { protocol, host } = window.location;
          this.teamShareLink = `${protocol}//${host}/thirdAnniversary/enter${getRandomString()}?friend_id=${this.activeInfo.team.team_code
            }`;
          this.eggPause = localStorage.getItem("thirdAnniversary_eggPause");

          // console.log("组队分享：", this.teamShareLink);

          // setTimeout(() => {
          this.initTeamShareData();
          // }, 1000);

          this.isActiveAppointment =
            this.activeInfo.team.activity_status === ACTIVE_APPOINTMENT_STATUS;

          // console.log("this.isActiveAppointment1111", this.isActiveAppointment);
        }
      }
    },
    logger: {
      immediate: true,
      handler (newVal) {
        if (newVal) {
          this.logger.sum("欧美三周年组队活动_组队消费页");
        }
      }
    }
  },
  methods: {
    // 海外登录SDK初始化
    async onInitQCHW () {
      const handleSdkCallback = (request, result, params) => {
        if (request === "login" && result === 0) {
          // 登录成功
          this.token = params.token;
          localStorage.setItem(this.pageLanguage.token, this.token);

          // 获取更详细用户信息
          const userInfo = QCHWSdk.getInstance().getUserInfo();
          this.user_id = userInfo.user_id;
          // this.email = userInfo.email;
          const maskedEmail = this.maskEmail(userInfo.email);
          this.email = maskedEmail;
          window.showLoadingPopup();

          setTimeout(() => {
            onGetAccountDataAPI({
              game_id: this.pageLanguage.sdkObj.game_id,
              token: this.token,
              platform: this.pageLanguage.sdkObj.platform,
              email: this.email
            }).then(response => {
              if (Number(response.code) == 200) {
                this.access_token = response.data.access_token;
                localStorage.setItem(
                  this.pageLanguage.access_token,
                  this.access_token
                );
                this.onInitDate(true);
              }
            });
          }, 500);
        } else if (request === "login" && result !== 0) {
          window.hideLoadingPopup();
          // console.warn('❌ 登录失败或取消')
        }
      };

      await QCHWSdk.getInstance().init({
        position: "web",
        game_id: this.pageLanguage.sdkObj.game_id,
        game_sign: this.pageLanguage.sdkObj.game_sign,
        game_version: "v1.0.0",
        spec_lang: this.pageLanguage.sdkObj.spec_lang,
        google_client_id: this.pageLanguage.sdkObj.google_client_id,
        apple_client_id: this.pageLanguage.sdkObj.apple_client_id,
        facebook_client_id: this.pageLanguage.sdkObj.facebook_client_id,
        login_ways: ["google", "apple", "facebook"],
        callback: handleSdkCallback
      });

      setTimeout(() => {
        this.onInitQCHWInfo();
      }, 500);
    },
    async onInitQCHWInfo () {
      const response = await QCHWSdk.getInstance().initUserInfo({
        quick_login: false
      });

      if (response.result === 0) {
        this.token = response.data.token;

        const userInfo = QCHWSdk.getInstance().getUserInfo();

        // this.email = userInfo.email;
        const maskedEmail = this.maskEmail(userInfo.email);
        this.email = maskedEmail;
      } else {
        // console.log('获取信息失败');
        // QCHWSdk.getInstance().login();
      }
    },
    // 邮箱处理
    maskEmail (email) {
      if (!email || typeof email !== "string" || !email.includes("@"))
        return email;

      const [username, domain] = email.split("@");

      if (username.length <= 4) {
        // 用户名太短，无法提取2位前缀和2位后缀，保留第1位+4星
        return username[0] + "****" + "@" + domain;
      }

      const prefix = username.slice(0, 2); // 前 2 位
      const suffix = username.slice(-2); // 后 2 位

      return `${prefix}****${suffix}@${domain}`;
    },
    // 事件委托
    handleGlobalClick (e) {
      let el = e.target;
      while (el && el !== document) {
        if (el.hasAttribute && el.hasAttribute("data-snail-report-name")) {
          const reportName = el.getAttribute("data-snail-report-name");
          this.logger.sum(`欧美三周年组队活动_${reportName}`);
          break;
        }
        el = el.parentNode;
      }
    },
    // 初始化
    onInitDate (isFirst = false) {
      onGetInitDataAPI({ access_token: this.access_token })
        .then(response => {
          this.onInitDataCallback({ ...response, needAccount: false });
          if (response.code == 401) {
            this.onToast(response.message);
            this.clearDate();
            localStorage.clear();
            this.onInitQCHW();
            return;
          }

          if (response.code !== 200) {
            !isFirst && this.onToast(response.message);
            return;
          }

          setTimeout(() => {
            this.getTeamListData();
          }, 50);

          this.activity = response.data.activity;
          this.user_info = response.data.user_info;
          this.user_id = response.data.user_info.user_id;
          this.role_name = response.data.user_info.role_name;
          this.server_name = response.data.user_info.server_name;

          // 免密登录token
          this.server_token = response.data.user_info.token;

          this.is_bind = response.data.activity.is_bind || 0;

          this.teamScore = Number(this.activeInfo.team.team_score) || 0;
          this.scoreList = this.activeInfo.team.score_list || [];
          this.rewardLevel = Number(this.activeInfo.team.level) || 0;
          this.rewardList = this.activeInfo.team.reward_list || [];
          this.teamOutStatus = this.activeInfo.team.team_out_status || false;

          if (this.activeInfo.team.is_has_out_news) {
            this.onToast(this.pageLanguage.is_has_out_news);
          }

          // 设置welfare-list的滚动位置
          const targetElement = document.getElementsByClassName("welfare-list");
          function updatePackageStatus (packages, teamScore) {
            return packages.map(function (pkg, index, arr) {
              if (teamScore >= pkg.score) {
                // 已解锁
                return (pkg.status = "unlock");
              } else {
                // 找到第一个未达标项 → locking
                var prevScore = index > 0 ? arr[index - 1].score : 0;
                if (teamScore >= prevScore && teamScore < pkg.score) {
                  // console.log("locking", pkg);
                  return (pkg.status = "locking");
                } else {
                  return (pkg.status = "locked");
                }
              }
            });
          }
          updatePackageStatus(this.packageList, this.teamScore);
          // console.log(this.packageList);
          // 查找 status 为 locking 的索引
          const idx = this.packageList.findIndex(
            item => item.status === "locking"
          );

          // 获取滚动容器
          if (targetElement[0]) {
            // 如果找到了 locking 的项，滚动到对应位置；否则滚动到第一个
            const targetIdx = idx !== -1 ? idx + 1 : 1;

            const targetDom = document.getElementsByClassName(
              `reward-item-${targetIdx}`
            )[0];
            if (targetDom) {
              targetElement[0].scrollTop = targetDom.offsetTop - 10;
            }
          }

          this.setUserInfo(response.data.user_info);
          this.setActiveInfo(response.data.activity);
        })
        .catch(err => {
          // 错误处理
          window.hideLoadingPopup();
        })
        .finally(() => {
          // 最终清理动作
          window.hideLoadingPopup();
        });
    },
    // 登录
    login () {
      QCHWSdk.getInstance().login();
    },
    // 注销
    logout () {
      QCHWSdk.getInstance().logout();
      this.clearDate();
      this.onInitQCHW();
      // this.onInitDate();
      // this.login();
    },
    clearDate () {
      localStorage.setItem("thirdAnniversary_eggPause", "");
      localStorage.setItem(this.pageLanguage.token, "");
      localStorage.setItem(this.pageLanguage.access_token, "");
      localStorage.setItem("role_id", "");
      this.user_info = {};
      this.token = "";
      this.access_token = "";
      this.teamActiveInfo = {};
      this.recallActiveInfo = {};
      this.teamList = Array.from({ length: 6 }, () => ({}));

      this.memberNum = 0;
      this.roleList = [];
      this.recallSharePlayerInfo = {};
      this.teamScore = 0;
      this.scoreList = [];
      this.rewardLevel = 0;
      this.rewardList = [];
      this.selectedRoleInfo = {};
      this.recallShareImg = "";
      this.teamShareImg = "";
      this.teamInvitationNum = 0;
      this.teamLevel = 0;
      this.teamShareCopy = {
        title: "",
        desc: "",
        linkText: ""
      };
      this.is_bind = 0;
      this.eggPause = false;
      this.packageList = this.pageLanguage.packageList.map(item => ({
        ...item,
        status: "locked"
      }));
      this.setInitUserInfo();
      this.setInitActiveInfo({ team: { gave_score: 0 } });
    },
    async getTeamInit () {
      const codeID = this.code || "";
      const authCode = this.auth_code || "";
      if (this.friend_id || codeID) {
        const response = await teamInitAPI({
          access_token: this.access_token,
          friend_id: this.friend_id,
          code: this.code,
          auth_code: authCode
        });
        if (response.code === 200) {
          const { is_my, number, is_join, level } = response.data.activity;
          if (is_my) {
            this.showPopup("teamJoinFailedMyselfShow");
            this.logger.sum("最强蜗牛_欧美三周年组队活动_入队失败弹窗（邀请自己）");
          } else if (is_join) {
            this.showPopup("teamJoinFailedHasTeamShow");
            this.logger.sum("最强蜗牛_欧美三周年组队活动_入队失败弹窗（已有队伍）");
          } else if (number === 6) {
            this.showPopup("teamJoinFailedFullStrengthShow");
            this.logger.sum("最强蜗牛_欧美三周年组队活动_入队失败弹窗（队伍已满）");
          } else {
            // this.teamInvitationNum = number === 0 ? 1 : number;
            this.teamInvitationNum = number;
            this.teamLevel = level;
            this.showPopup("teamInvitationJoinShow");
          }
        } else {
          this.onToast(response.message);
        }
      }
    },
    goLink (url, label) {
      if (url === "") return;
      this.logger.sum(label);
      Indicator.open();
      setTimeout(() => {
        // console.log("跳转链接：", url);
        window.location.href = url;
        Indicator.close();
      }, 200);
    },
    enterUrl () {
      const currentItem =
        this.pageLanguage["activitiesCards" + this.language].find(
          (i, index) => index === this.activeIndex
        ) || {};

      const { label, url, time } = currentItem;

      if (this.isNotStarted(time)) return;

      if (this.activeIndex === 2) {
        this.toRecharge("运营活动");
        return;
      }

      this.goLink(url, `欧美三周年组队活动_${label}跳转`);
    },
    initSwiper () {
      this.activitiesSwiper = new Swiper(".activities-swiper-container", {
        slidesPerView: 1,
        loop: true,
        autoplay: 3000,
        pagination: ".activities-swiper-pagination",
        paginationClickable: true,
        nextButton: ".activities-swiper-button-next",
        prevButton: ".activities-swiper-button-prev",
        onSlideChangeStart: swiper => {
          this.activeIndex = swiper.realIndex;
        }
      });
      this.activeIndex = this.activitiesSwiper.realIndex;
    },
    isNotStarted (time) {
      const current = this.parseTimeStr(this.currentTime);
      const target = this.parseTimeStr(time);
      return target.getTime() > current.getTime();
    },

    parseTimeStr (str) {
      if (!str) return new Date("");

      // 清理空格
      str = str.trim();

      // 拆分日期和时间
      const [dateStr, timeStr = "00:00:00"] = str.split(" ");

      const [year, month, day] = dateStr.split(/[-\/]/).map(Number);
      const [hour, minute, second] = timeStr.split(":").map(Number);

      // 注意：month 需要 -1
      return new Date(year, month - 1, day, hour, minute, second);
    },
    openFindTeamShow () {
      if (this.userInfo.user_id === undefined) {
        this.login();
        return;
      }
      this.logger.sum("欧美三周年组队活动_寻找搭子按钮");
      this.showPopup("findTeamShow");
    },
    toGroupOfDiscord () {
      this.logger.sum("欧美三周年组队活动_寻找组队搭子-discord");
      window.location.href = this.pageLanguage.discord;
    },
    initTeamShareData () {
      try {
        this.teamShareCopy = {
          title: this.pageLanguage.teamShareTitle,
          desc: this.pageLanguage.teamShareDesc,
          linkText: this.pageLanguage.teamShareLinkText
        };
        // 例如：获取好友助力信息等
      } catch (err) {
        // 错误信息
        // console.log('组队分享初始化失败', err);
      }
    },
    onCopy (id) {
      const clipboard = new Clipboard(`#${id}`);
      clipboard.on("success", e => {
        this.onToast(this.pageLanguage.copy_success);
        if (id === "team-clipboard-btn" && this.language === "en") {
          setTimeout(() => {
            this.toGroupOfDiscord();
          }, 500);
        }
        e.clearSelection();
      });
      clipboard.on("error", e => {
        this.onToast(this.pageLanguage.copy_error);
      });
    },
    onTeamShare () {
      if (this.userInfo.user_id === undefined) {
        this.login();
        return;
      }
      this.showPopup("teamNotWechatShareShow");
    },
    closeWechatShare (popupName) {
      this.closePopup(popupName);
      window.history.replaceState(null, "", window.location.pathname);
    },
    getTeamListData () {
      let teamList = this.activeInfo.team.team_list || [];
      // console.log("this.activeInfo:", this.activeInfo);
      // console.log("this.userInfo:", this.userInfo);
      teamList.forEach(item => {
        const { status } = item;
        item.type_desc = PLAYER_TYPE[status];
        // console.log("this.userInfo:", this.userInfo);
        // console.log("this.userInfo.user_id:", this.userInfo.user_id);
        // console.log("item.id:", item.id);
        item.is_myself = this.userInfo.user_id === item.id;
        item.is_kick_out =
          this.activeInfo.team.activity_status === ACTIVE_APPOINTMENT_STATUS &&
          this.activeInfo.team.is_first &&
          !item.is_myself &&
          !this.activeInfo.team.team_out_status;

        // console.log("item", item);
        if (item.is_first) {
          item.is_kick_out = false;
        }
      });
      // 如果teamList长度小于6，用空对象填充
      if (teamList.length < 6) {
        const fillCount = 6 - teamList.length;
        const fillArray = Array.from({ length: fillCount }, () => ({}));
        teamList = teamList.concat(fillArray);
      }
      this.teamList = teamList;
      this.memberNum = this.activeInfo.team.team_list.length;
    },
    // 查看我的组队
    toMyTeamByTeam () {
      this.closePopup("teamJoinFailedHasTeamShow");
      this.scrollIntoTeamBox();
    },
    scrollIntoTeamBox () {
      const targetElement = document.getElementById("team-consumption-box");
      if (targetElement) {
        targetElement.scrollIntoView({ behavior: "smooth" });
      }
    },
    readPlayerInfo (id) {
      if (this.userInfo.user_id === undefined) {
        this.login();
        return;
      }
      const curPlayerInfo = this.teamList.find(item => item.id === id);

      if (!curPlayerInfo) return;
      this.curPlayerInfo = curPlayerInfo;
      if (this.curPlayerInfo.is_kick_out) {
        clearInterval(this.kickOutTimer);
        this.kickOutSeconds = 10;
        this.showGrayKickOutBtn = true;
        this.kickOutTimer = setInterval(() => {
          this.kickOutSeconds--;
          if (this.kickOutSeconds <= 0) {
            clearInterval(this.kickOutTimer);
            this.showGrayKickOutBtn = false;
          }
        }, 1000);
      }
      this.showPopup("teamPlayerInfoShow");
    },
    kickoutPlayer (id) {
      if (this.userInfo.user_id === undefined) {
        this.login();
        return;
      }
      const curPlayerInfo = this.teamList.find(item => item.id === id);
      // console.log("curPlayerInfo", curPlayerInfo);
      if (!curPlayerInfo) return;
      this.curPlayerInfo = curPlayerInfo;
      if (this.curPlayerInfo.is_kick_out) {
        clearInterval(this.kickOutTimer);
        this.kickOutSeconds = 10;
        this.showGrayKickOutBtn = true;
        this.kickOutTimer = setInterval(() => {
          this.kickOutSeconds--;
          if (this.kickOutSeconds <= 0) {
            clearInterval(this.kickOutTimer);
            this.showGrayKickOutBtn = false;
          }
        }, 1000);
      }
      this.showPopup("teamKickoutShow");
    },
    // 踢出队伍
    async onKickOut () {
      if (this.userInfo.user_id === undefined) {
        this.login();
        return;
      }
      this.onPreventShow();
      const response = await teamKickAPI({
        access_token: this.access_token,
        id: this.curPlayerInfo.id
      });
      if (response.code !== 200) {
        this.onToast(response.message);
      } else {
        this.onToast(this.pageLanguage.onKickOutSgin);
        this.closePopup("teamKickoutShow");
        this.onInitDate();
        this.logger.sum("欧美三周年组队活动_弹窗-踢出队伍");
      }
      this.onPreventClose();
    },
    // 查看更多积分
    onMorePoints () {
      if (this.userInfo.user_id === undefined) {
        this.login();
        return;
      }
      if (this.isActiveAppointment) {
        this.onToast(this.pageLanguage.onMorePoints);
        return;
      }
      if (this.teamScore) {
        this.showPopup("teamPointsRecordShow");
      } else {
        this.showPopup("teamNotPointsRecordShow");
      }
    },
    pointToRecharge () {
      if (this.userInfo.user_id === undefined) {
        this.login();
        return;
      }
      if (this.isActiveAppointment) {
        this.onToast(this.pageLanguage.onMorePoints);
        return;
      }
      toRecharge('宝库', 'official');
    },
    // 免密跳转到充值网站
    async toRecharge (target, source) {
      if (this.isActiveAppointment) {
        this.onToast(this.pageLanguage.toRecharge);
        return;
      }
      this.logger.sum(`欧美三周年组队活动_${this.pageLanguage.language}${target}官充跳转`);

      // 根据来源区分 flag
      let flag = "pay-koi-activity";

      // 官充活动
      if (source === "official") {
        flag = "pay-web";
      }

      try {
        const authPlugin = new QCJumpAuthPlugin({
          gameId: this.pageLanguage.sdkObj.game_id,
          language: this.pageLanguage.language
        });
        const link = await authPlugin.generateLoginFreeUrl({
          gameId: this.pageLanguage.sdkObj.game_id,
          flag: flag,
          accessToken: this.server_token,
          extraParams: {
            role_id: this.userInfo.rid,
            role_name: this.userInfo.role_name,
            server_id: this.userInfo.server_id,
            server_name: this.userInfo.server_name
          }
        });

        window.location.href = link;
      } catch (error) {
        // console.error('生成免登录链接失败:', error);
        window.location.href = this.pageLanguage.rechargeUrl;
      }
    },
    async onExitTeam () {
      if (this.userInfo.user_id === undefined) {
        this.login();
        return;
      }
      this.onPreventShow();
      const response = await teamExitAPI({ access_token: this.access_token });
      if (response.code !== 200) {
        this.onToast(response.message);
      } else {
        this.closePopup("teamExitShow");
        this.onInitDate();
        this.onToast(response.message);
      }
      this.onPreventClose();
    },
    async rejectJoinTeam () {
      this.closePopup("teamInvitationJoinShow");
    },
    async agreeJoinTeam () {
      if (this.needInvitationConfirm) {
        this.closePopup("teamInvitationJoinShow");
        this.showPopup("teamInvitationConfirmShow");
        this.needInvitationConfirm = false;
        return;
      }
      this.onPreventShow();
      const response = await teamJoinAPI({
        access_token: this.access_token,
        friend_id: this.friend_id,
        code: this.code,
        auth_code: this.auth_code
      });
      if (response.code !== 200) {
        this.onToast(response.message);
      } else {
        this.onToast(this.pageLanguage.joinSuccess);
      }
      this.needInvitationConfirm = true;
      this.onPreventClose();
      this.closePopup("teamInvitationJoinShow");
      this.closePopup("teamInvitationConfirmShow");
      this.onInitDate();
    },
    // 格式化日期
    formatDate (dateStr) {
      const date = new Date(dateStr);
      const month = date.getMonth() + 1;
      const day = date.getDate();
      const hours = date.getHours();
      const minutes = date.getMinutes();
      const seconds = date.getSeconds();
      return `${month}-${day} ${hours}:${minutes >= 10 ? minutes : "0" + minutes
        }:${seconds >= 10 ? seconds : "0" + seconds}`;
    },
    openLoginByScore () {
      if (this.userInfo.user_id === undefined) {
        this.login();
      }
    },
    openLoginByPlayer () {
      // console.log(this.userInfo.user_id)
      if (this.userInfo.user_id === undefined) {
        this.login();
      }
    },
    // TAG: 其他简易封装的方法
    onToast (config, duration) {
      const curConfig = {
        duration: duration || 1000,
        className: "toasts"
      };
      if (!config) {
        console.error("缺少config参数");
        return false;
      }
      if (typeof config === "string") {
        curConfig.message = config;
      }
      Toast(curConfig);
    },
    // 打开遮罩
    onPreventShow () {
      Indicator.open();
      this.preventShow = true;
    },
    // 关闭遮罩
    onPreventClose () {
      Indicator.close();
      this.preventShow = false;
    },
    showPopup (name) {
      if (name == "eggPopShow") {
        if (this.userInfo.user_id === undefined) {
          this.login();
          return;
        }
        localStorage.setItem("thirdAnniversary_eggPause", true);
        this.eggPause = true;
      }
      this[name] = true;
    },
    closePopup (name) {
      this[name] = false;
    },
    inputFocus () {
      if (this.timer) {
        clearTimeout(this.timer);
      }
    },
    inputFocusOut () {
      this.timer = setTimeout(() => {
        window.scrollTo(0, 0);
      }, 10);
    },
    ...mapMutations([
      "setUserInfo",
      "setInitUserInfo",
      "setInitActiveInfo",
      "setActiveInfo"
    ]),
    ...mapActions(["onInitDataCallback"])
  }
};
</script>
<style lang="less" scoped>
@import url("./index.less");
</style>



// WEBPACK FOOTER //
// src/pages/thirdAnniversary/index/index.vue